<script>
import OrganizationManagement from '@/components/backoffice/organization/OrganizationManagement.vue'
import RolesManagement from '@/components/backoffice/roles/RolesManagement.vue'
import UserManagement from '@/components/backoffice/user/UserManagement.vue'
import { EventBus } from '@/helpers/eventBus'
export default {
  name: 'Backoffice',
  components: {
    RolesManagement,
    UserManagement,
    OrganizationManagement
  },
  data() {
    return {
      updated: false,
      activeTab: 'user',
      notification: {
        state: false,
        message: '',
        type: 'success'
      },
      loading: {
        roles: false,
        user: false,
        organizations: false
      },
      roles: [],
      user: [],
      organizations: [],
    }
  },
  created() {
    this.getRoleView()
    this.getUserView()
    this.getOrganizationView()
    EventBus.$off('backoffice_notification')
    EventBus.$on('backoffice_notification', notificationData => {
      this.notification = notificationData
    })
  },
  methods: {
    async getRoleView() {
      this.roles = []
      this.loading.roles = true
      await this.$backofficeService
        .roleView()
        .then(response => {
          this.roles = response.roles
        })
        .catch(() => {})
        .finally(() => {
          this.loading.roles = false
        })
    },
    async getUserView() {
      this.user = []
      this.loading.user = true
      await this.$backofficeService
        .userView({ query: '' })
        .then(response => {
          this.user = response.userResponseDTOs
        })
        .catch(() => {})
        .finally(() => {
          this.loading.user = false
        })
    },
    async getOrganizationView() {
      this.organizations = []
      this.loading.organizations = true
      await this.$backofficeService
        .organizationView({ query: '' })
        .then(response => {
          this.organizations = response.organizations
        })
        .catch(() => {})
        .finally(() => {
          this.loading.organizations = false
        })
    },
    createdOrganization() {
      setTimeout(()=>this.getOrganizationView().then(() => {
        this.updated = !this.updated
        this.notification = {
          state: true,
          message: this.$t('page.backoffice.view.organization.created.success'),
          type: 'success'
        }
      }), 300)
    }
  }
}
</script>
<template>
  <v-container :fluid="$vuetify.breakpoint.lgAndDown" style="padding-bottom: 100px;">
    <v-snackbar
      v-model="notification.state"
      :color="notification.type"
      multi-line
      top>
      <span v-html="notification.message" />
      <v-btn color="white" text @click="notification.state = false">
        <v-icon size="20"> mdi-close </v-icon>
      </v-btn>
    </v-snackbar>
    <v-card>
      <v-tabs v-model="activeTab" show-arrows>
        <v-tabs-slider />
        <v-tab href="#user">
          <v-icon>mdi-account-group-outline</v-icon>
          <span class="pl-1">{{$t('page.backoffice.view.tab.user')}}</span>
        </v-tab>
        <v-tab href="#roles">
          <v-icon>mdi-account-cog-outline</v-icon>
          <span class="pl-1">{{$t('page.backoffice.view.tab.roles')}}</span>
        </v-tab>
        <v-tab href="#organizations">
          <v-icon>mdi-domain</v-icon>
          <span class="pl-1">{{$t('page.backoffice.view.tab.organizations')}}</span>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="activeTab">
        <v-tab-item value="user">
          <v-divider/>
          <v-card flat tile>
            <v-card-text class="text-center">
              <UserManagement
                v-if="roles.length"
                v-model="user"
                :roles="roles"
                :loading="loading.user"
              />
              <v-progress-circular v-else />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item value="roles">
          <v-divider/>
          <v-card flat tile>
            <v-card-text>
              <RolesManagement
                v-model="roles"
                :loading="loading.roles"
                @added="getRoleView"
                @deleted="getRoleView"
              />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item value="organizations">
          <v-divider/>
          <v-card flat tile>
            <v-card-text>
              <OrganizationManagement
                :key="updated"
                :organizations="organizations"
                :roles="roles"
                :loading="loading.organizations"
                @create-organization="createdOrganization"
              />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>
